import type { ReactNode } from 'react';
import type { Team } from '@/common/api/types/teams';

export interface TeamSelectOption {
  value: number;
  label: string;
  icon: ReactNode | null;
}

export const mapTeamToSelectOption = (team: Team): TeamSelectOption => ({
  value: team.id,
  label: team.name,
  icon: team.icon ? <img src={team.icon} alt={team.name} className="w-4 h-4 rounded-full" /> : null,
});
